import styled from "styled-components";

export const Container = styled.div`
  .editContainer {
    margin-top: 24px;
  }
`;
